import React, { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import AdminHeader from "./AdminHeader";
import "./AdminLayout.css";

const AdminLayout = () => {
  const location = useLocation();

  // ✅ FIX: handle both with/without trailing slash
  const isAdminHome =
    location.pathname === "/components/Admins/AdminLayout" ||
    location.pathname === "/components/Admins/AdminLayout/";
  const getGreeting = () => {
    const hour = new Date().getHours();

    if (hour < 12) return "Good Morning,";
    if (hour >= 17) return "Good Evening,";
    return "Good Afternoon,";
  };

  const [greeting, setGreeting] = useState(getGreeting);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setGreeting(getGreeting());
    }, 60000);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <div className="admin-container">
      <AdminHeader />

      <div className="dashboard-main">
        <main className="dashboard-main">

          {/* ✅ SHOW HERO ONLY ON HOME */}
          {isAdminHome && (
            <section className="admin-layout-hero">
              <section className="admin-layout-copy">
                <span className="admin-layout-chip"> Welcome </span>
                <h1>{greeting}</h1>
                <p>With great admin rights comes great responsibility..</p>
              </section>

              <section className="admin-layout-figure" aria-hidden="true">
                <div className="admin-layout-sun" />
                <div className="admin-layout-cloud admin-layout-cloud-one" />
                <div className="admin-layout-cloud admin-layout-cloud-two" />
                <div className="admin-layout-skyline">
                  <span className="tower tower-1" />
                  <span className="tower tower-2" />
                  <span className="tower tower-3" />
                  <span className="tower tower-4" />
                  <span className="tower tower-5" />
                  <span className="tower tower-6" />
                  <span className="tower tower-7" />
                  <span className="tower tower-8" />
                  <span className="tower tower-9" />
                  <span className="tower tower-10" />
                </div>
              </section>
            </section>
          )}

          {/* ✅ CRITICAL FIX: CHILD ROUTES RENDER HERE */}
          <Outlet />

        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
